import type { CountryService } from '@wizbii/utils/models';

import { createReducer, on } from '@ngrx/store';
import { loadServicesSuccess } from '@stores/services/services.action';

export interface CountryServiceExtended extends CountryService {
  supportEmails?: Record<string, string>;
}

export const serviceKey = 'service';

export type ServiceState = {
  service?: CountryServiceExtended;
};

const initialState: ServiceState = { service: undefined };

export const serviceReducer = createReducer(
  initialState,
  on(loadServicesSuccess, (_, { service }) => {
    return { service };
  })
);
